import React from "react";
import {Form, Input, InputNumber, message, Select} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from "../../../utils/NHFetch";
import NHSelect from '../../common/NHSelect/index'
import NHInputPicker from '../../common/NHInputPicker/index';

const FormItem = Form.Item;
const basicUrl = "/xxcj/zdgl/";

/**
 * @author weishihuai
 * @date 2018/6/29
 * @time 16:59
 * @Description: 迎新系统-字段编辑表单
 */
class EditForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            xxxxSelectData: [],  //学校下拉选择框数据
            zdcdShow: true,      //是否显示
        }
    }

    static defaultProps = {
        initData: {
            pkid: '',
            zdbz: '',
            zdmc: '',
            zdlx: '',
            zdcd: '',
            zdsx: '',
            zdms: '',
            kjcs: '',
            xxdm: '',
            isUpdate: false
        }
    };

    componentDidMount() {
        const {zdlx} = this.props.initData;
        this.handleZdlxChangeListener(zdlx);
        NHFetch(basicUrl + "getXxxx", "GET")
            .then(resData => {
                if (resData.data) {
                    this.setState({
                        xxxxSelectData: resData.data,
                    })
                } else {
                    message.error("无法查询到当前学校，请先设置当前学校！")
                }
            })
    }

    //字段类型Change事件
    handleZdlxChangeListener = (value) => {
        let flag = 'DATE' === value || 'NUMBER' === value;
        this.setState({
            zdcdShow: !flag
        });
    };

    render() {
        const {form, initData} = this.props;
        const {xxxxSelectData} = this.state;
        let xxOptions = [];
        if (xxxxSelectData) {
            xxOptions = xxxxSelectData.map((item, index) => <Select.Option key={index}
                                                                           value={item.VALUE}>{item.LABEL}</Select.Option>);
        }

        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'zdmc'} label={'字段名称'} hasFeedback={true} form={form} required={true}
                                pattern={{max: 300, message: '字段名称长度不能超过300字符！'}}
                                initialValue={initData.zdmc}>
                        <Input placeholder="请输入字段名称"/>
                    </NHFormItem>
                    <NHFormItem id={'zdlx'} label={'字段类型'} form={form}
                                initialValue={initData.zdlx ? initData.zdlx : 'VARCHAR2'} required={true}>
                        <Select placeholder='请选择...' onChange={this.handleZdlxChangeListener}>
                            <Select.Option value=''>请选择...</Select.Option>
                            <Select.Option value='VARCHAR2'>文本类型</Select.Option>
                            <Select.Option value='DATE'>日期类型</Select.Option>
                            <Select.Option value='NUMBER'>数字类型</Select.Option>
                        </Select>
                    </NHFormItem>
                    <NHFormItem id={'zdcd'} label={'字段长度'} hasFeedback={true} form={form} required={this.state.zdcdShow}
                                initialValue={initData.zdcd ? initData.zdcd : 100} showFlag={this.state.zdcdShow}>
                        <InputNumber min={1} max={9999}/>
                    </NHFormItem>
                    <NHFormItem id={'zdsx'} label={'字段属性'} form={form} required={true}
                                initialValue={initData.zdsx ? initData.zdsx : '2'}>
                        <NHSelect sign="dmk_xtgl_zdsx"/>
                    </NHFormItem>
                    <NHFormItem id={'zdms'} label={'字段描述'} hasFeedback={true} form={form}
                                pattern={{max: 300, message: '字段描述长度不能超过300字符！'}}
                                initialValue={initData.zdms}>
                        <Input placeholder="请输入字段描述"/>
                    </NHFormItem>
                    <NHFormItem id={'kjcs'} label={'输入控件类型'} form={form} required={true}
                                initialValue={initData.kjcs ? initData.kjcs : ''}>
                        <NHInputPicker/>
                    </NHFormItem>
                    <NHFormItem id={'xxdm'} label={'学校代码'} hasFeedback={true} form={form}
                                initialValue={initData.xxdm ? initData.xxdm : (initData.isUpdate ? "" : (xxxxSelectData.length > 0 ? xxxxSelectData[0].VALUE : ""))}>
                        <Select placeholder='请选择...'>
                            <Select.Option value="">请选择...</Select.Option>
                            {xxOptions}
                        </Select>
                    </NHFormItem>
                </Form>
            </div>
        );
    }
}

const editForm = Form.create()(EditForm);

export default editForm;



// WEBPACK FOOTER //
// ./components/xxcj/zdgl/EditForm.js